"use client";

import { Mail, Phone, Send, Store, Wheat, Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-accent border border-border text-center">
        <p className="text-accent-foreground font-default text-2xl mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white">
          Enviar otro mensaje
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" rules={{
      required: "Por favor, indica tu nombre",
      minLength: {
        value: 2,
        message: "Mínimo 2 caracteres"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default tracking-wide">Nombre</FormLabel>
            <FormControl>
              <Input placeholder="Tu nombre" className="h-12 bg-transparent border-b border-input focus:border-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "El email es obligatorio",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Introduce un email válido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default tracking-wide">Correo electrónico</FormLabel>
            <FormControl>
              <Input type="email" placeholder="ejemplo@correo.com" className="h-12 bg-transparent border-b border-input focus:border-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default tracking-wide">
              Teléfono <span className="text-muted-foreground font-normal italic">(opcional)</span>
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+34 000 000 000" className="h-12 bg-transparent border-b border-input focus:border-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="subject" rules={{
      required: "Por favor, elige un motivo"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default tracking-wide">Motivo de consulta</FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="w-full h-12 bg-transparent border-b border-input focus:border-primary">
                  <SelectValue placeholder="Selecciona una opción" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="general">Consulta general</SelectItem>
                  <SelectItem value="medicina">Medicina capilar</SelectItem>
                  <SelectItem value="cirugia">Cirugía capilar</SelectItem>
                  <SelectItem value="otros">Otros</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Por favor, escribe tu mensaje",
      minLength: {
        value: 10,
        message: "Mínimo 10 caracteres"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default tracking-wide">Mensaje</FormLabel>
            <FormControl>
              <Textarea placeholder="Cuéntanos cómo podemos ayudarte..." rows={6} className="bg-transparent border border-input resize-none focus:border-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="newsletter" render={({
      field
    }) => <FormItem>
            <div className="flex items-start gap-3 pt-2">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} className="mt-1" />
              </FormControl>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                <Label className="text-foreground font-normal cursor-pointer">
                  Deseo recibir información sobre salud capilar
                </Label>
              </div>
            </div>
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/30">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <div className="flex flex-col sm:items-end gap-3 pt-2">
        <Button type="submit" disabled={isSubmitting} size="lg" className="px-8 h-12 bg-primary text-primary-foreground hover:bg-secondary w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Enviando...
            </> : <>
              Solicitar consulta
              <Send className="ml-1 size-4" />
            </>}
        </Button>
        <p className="font-default italic text-sm text-muted-foreground">
          Respondemos en un plazo de 24-48 horas laborables.
        </p>
      </div>
    </Form>;
}
export default function FormularioDeConsultaDirecta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const contactCards = [{
    icon: Mail,
    label: "Email",
    value: "info@msinstitutocapilar.com",
    note: ""
  }, {
    icon: Phone,
    label: "Teléfono",
    value: "+34 626 475 620",
    note: "Atención personalizada"
  }, {
    icon: Store,
    label: "Ubicación",
    value: "C/ Cruces 7, Las Rozas, Madrid",
    note: "Clínica privada"
  }];
  return;
}